module.exports = __webpack_public_path__ + "assets/img/kv-4c12743b.jpg";